import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import React from "react";
import { HeaderComponent } from "../../../components/HeaderComponent/HeaderComponent";
import { HeaderSpacer } from "../../_layout-helpers/spacers";
import { Spacer } from "../../../components/_shared-components/arrangement/Space";

import { FooterComponent } from "../../../components/FooterComponent/FooterComponent";
import { ComponentRenderer } from "../../_layout-helpers/component-renderer";
import { Navigate } from "react-router";
import { ExtractSwarovskiPageData, PurchaseConfirmationPageData } from "@swo/storefront";
import { SwagSlugBuilder } from "@swo/shared";
import { usePaymentStep } from "./use-payment-step";
import { PurchaseConfirmationPageContent } from "./purchase-confirmation-page-content";
import { loadingScreen } from "./shared-components/loading-screen";
import { useStore } from "../../../store/hooks/use-store";
import { t2, useT2 } from "../../../domain/translations/translations";

export const PurchaseConfirmationPageLayout: ReactTFC<
  ExtractSwarovskiPageData<PurchaseConfirmationPageData>
> = props => {
  const homepageLink = SwagSlugBuilder.path(props.locale, props.segment, "");
  const [paymentStep, updatePaymentStep] = usePaymentStep();
  const userAspect = useStore().state.auth;

  const gt = useT2(props.generalTranslations);
  const t = useT2(props.data.translations);

  if (!paymentStep) {
    return <Navigate to={homepageLink} />;
  }

  const repeatPaymentLink = (orderId: string) => ({
    pathname: props.page.path,
    search: `?${new URLSearchParams({ orderId, "pay-again": "true" }).toString()}`,
  });

  const orderPageLink = (orderId: string) => ({
    pathname: props.page.path,
    search: `?${new URLSearchParams({ orderId }).toString()}`,
  });

  const isUISimplified = paymentStep.tag === "pay-again";

  const contentAreaComponents =
    props.data.components.length > 0 ? (
      <ComponentRenderer components={props.data.components} localeForNumberFormat={props.locale} translations={gt} />
    ) : null;

  return (
    <>
      <meta name="robots" content="noindex" />

      <HeaderComponent header={props.data.header} version={isUISimplified ? "simplified" : "normal"} />
      <HeaderSpacer />
      <Spacer size={"md"} />

      {userAspect ? (
        <PurchaseConfirmationPageContent
          paymentStep={paymentStep}
          updatePaymentStep={updatePaymentStep}
          homepageLink={homepageLink}
          t={t}
          linkToPurchaseConfirmation={props.data.linkToPurchaseConfirmation}
          locale={props.locale}
          authToken={userAspect.authToken}
          repeatPaymentLink={repeatPaymentLink(paymentStep.context.orderId)}
          orderPageLink={orderPageLink(paymentStep.context.orderId)}
          contentAreaComponents={contentAreaComponents}
        />
      ) : (
        loadingScreen
      )}

      <Spacer size={"md"} />
      <FooterComponent {...props.data.footer} simplified={isUISimplified} />
    </>
  );
};
